var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.967 22.5a1.5 1.5 0 00-1.5-1.5c-4.9 0-7.917-1.1-9.432-3.621a.25.25 0 01.214-.379H14.8a1.5 1.5 0 000-3H9.179a.249.249 0 01-.249-.222A15.788 15.788 0 018.833 12c0-.09 0-.175.006-.261a.25.25 0 01.25-.239h7.578a1.5 1.5 0 000-3H9.589a.25.25 0 01-.239-.326C10.5 4.552 13.656 3 19.467 3a1.5 1.5 0 000-3C16.485 0 8.121.008 6.224 8.306a.25.25 0 01-.243.194H4.533a1.5 1.5 0 000 3h1.054a.253.253 0 01.18.076.249.249 0 01.07.183V12c0 .607.028 1.18.079 1.727a.252.252 0 01-.253.273H4.535a1.5 1.5 0 000 3h1.884a.251.251 0 01.235.164C9.15 23.994 16.673 24 19.467 24a1.5 1.5 0 001.5-1.5z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.f6c05245.svg";
export { ForwardRef as ReactComponent };